<template>
<v-container>
  <v-row justify="center">
<v-flex v-bind="{[`sx${DPI*4} sm${DPI*4} md${DPI*4} lg${DPI*4} xl${DPI*3}`]: true}">

    <v-card flat class="pt-5 mt-5" > 
        <v-app-bar           
            dark 
            color="primary"
            height="50"
            :app="fab"
        >
            
        <v-toolbar-title class="white--text">Please connect</v-toolbar-title>

      <v-spacer></v-spacer>
        <!-- <v-btn text  class="pa-1" href="http://update.terra1.lt/u/mhd001" target="_blank"> User manual
          <v-icon right  class="px-1 ml-0">help_outline</v-icon>
        </v-btn> -->
        <v-btn icon disabled class="pa-1 ml-0" > 
          <v-icon right  class="px-1 ml-0">exit_to_app</v-icon>
        </v-btn>
        </v-app-bar>
        <v-layout column align-center justify-center fill-height class="ma-5 pa-5" v-if="this.$store.getters.isSupported">
          <message></message>
        <v-flex class="ml-3 pl-3 mb-4 pb-4">
          <v-img max-width="160" src="MHD001_w320px.jpg" ></v-img>
              <!-- <v-icon size="300">$vuetify.icons.scanAnime </v-icon>           -->
        </v-flex>
        <!-- <v-img 
            max-width="240"
            src="MHD001.jpg"
            
          ></v-img> -->
        <v-flex class=" mb-5 mb-5" >
          <v-btn dark color="primary" class=" mb-2"  @click="buttonclick">Connect</v-btn>       
        </v-flex>
        </v-layout>
        <v-card class="error--text ma-5 ma-5" v-else >
          <v-card-title>Error</v-card-title>    
          <v-card-text >
            You Are Using An Unsupported Browser
          </v-card-text>        
        </v-card>
        <v-footer dark color="primary " class="font-weight-medium" :app="fab">
        <v-flex text-center xs12>
          Copyright {{   new Date().getFullYear() }} <strong>&copy; All rights reserved</strong>
        </v-flex>
        <v-spacer></v-spacer>
        </v-footer>
    </v-card>
</v-flex>
  </v-row>
</v-container>
</template>

<script>

import message from '../components/message'

export default {
    name:'scan',
    components: {
      message
    },
    data(){
        return{
            devices: [],
            DPI:0,
            appState:false,
            fab:false
        }
    },
    beforeMount:function(){
      this.DPI = window.devicePixelRatio
      if (this.DPI>1)
      {
        this.DPI = 8
        this.fab = true
      }
      else
      {
        this.DPI = 1
        this.fab = false
      }

        console.log("DPI: " + this.DPI)
    setTimeout(this.toMount, 500)
    },
    methods: {
      buttonclick:async function () 
      {
        this.overlay = !this.overlay
        await this.$store.dispatch('connectToDevice')
        
      },
      isSupported: function(){
        return this.$store.getters.isSupported
      }
    }  

}
</script>